module.exports = __webpack_public_path__ + "static/img/hy3.c583111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/hy3.png
// module id = YEmR
// module chunks = 2